import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { TSpinType } from 'interfaces';

const TYPE_STYLES: Record<TSpinType, FlattenSimpleInterpolation> = {
  fit: css`
    width: fit-content;
  `,
  static: css`
    width: 100%;
  `,
  fixed: css`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 12px;
  `,
  absolute: css`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 12px;
  `
};

export const SpinWrapper = styled.div<{
  $type: TSpinType;
  $withBackground: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  ${({ $withBackground }) =>
    $withBackground &&
    css`
      background: var(--v3-black-0);
    `}
  ${({ $type }) => TYPE_STYLES[$type]};

  .ant-spin-dot-item {
    background-color: var(--v3-primary-color);
  }
`;
